import Req from '../../$axios';

const serviceModule = {
  // 用户角色列表
  userRolesIndex(params) {
    return Req({
      url: 'users/userRolesIndex',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 用户角色详情
  userRolesShowByUid(params) {
    return Req({
      url: 'users/userRolesShowByUid',
      method: 'get',
      isJSON: true,
      tip: true,
      isAlertErr: true,
    }, params);
  },
  //更新用户角色
  updateUserRoles(params) {
    return Req({
      url: 'users/updateUserRoles',
      method: 'post',
      isJSON: true,
      tip: true,
      isAlertErr: true,
    }, params);
  },
  //用户权限详情
  userPermissionsShowByUid(params) {
    return Req({
      url: 'users/userPermissionsShowByUid',
      method: 'get',
      isJSON: true,
      tip: true,
      isAlertErr: true,
    }, params);
  },
  // 更新用户权限
  updateUserPermissions(params) {
    return Req({
      url: 'users/updateUserPermissions',
      method: 'post',
      isJSON: true,
      tip: true,
      isAlertErr: true,
    }, params);
  },
};

export default {
  ...serviceModule
};
